import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.pages.AppQuotesPage.';
  public static readonly quoteSummaryTitle = `${Id.prefix}quoteSummaryTitle`;
}

export class LangAppQuotesPage {
  private constructor() {}
  public static quoteSummaryTitle(): string {
    return interpolate(Id.quoteSummaryTitle);
  }
}

export class AppQuotesPageModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.quoteSummaryTitle, "{{glossary 'quote'}} Summary", 'Title for the quotes summary page');
  }
}
